import { Box, Typography } from '@mui/material';
import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

import { LoanValue } from '@components/overviewPanels/existingLoanPanel/ExistingLoanPanel';

interface LegendEntry {
    loan: LoanValue;
    index?: number;
    colors?: string[];
    currencyCode: string;
}

const LegendEntry = ({ loan, index, colors, currencyCode }: LegendEntry) => {
    const { theme } = useTheme();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="overline">{loan.name}</Typography>
            <Box
                data-testid={`legend-entry-${loan.id}`}
                sx={{
                    mb: 1,
                    ...(index != null && {
                        '&::before': {
                            content: '"•"',
                            ...(colors != null && {
                                color: colors[index % colors.length],
                            }),
                            fontSize: theme.typography.h5.fontSize,
                            marginRight: '3px',
                        },
                    }),
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                <Typography variant="h2">
                    <CurrencyFormatter
                        currency={currencyCode}
                        amount={loan?.value}
                        testId={`${loan?.id}-loan-amount`}
                    />
                </Typography>
            </Box>
        </Box>
    );
};

export default LegendEntry;
